"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    schedule: zod_1.z.string((0, validation_1.labelZodErrors)("Schedule")).optional(),
    assignToSubmitter: zod_1.z
        .boolean((0, validation_1.labelZodErrors)("Auto assign to submitter"))
        .optional(),
});
const dataSchema = zod_1.z.object({
    schedule: zod_1.z
        .string((0, validation_1.labelZodErrors)("Schedule"))
        .min(1, "Schedule is required."),
    timezone: zod_1.z
        .string((0, validation_1.labelZodErrors)("Timezone"))
        .min(1, "Timezone is required."),
    assignToSubmitter: zod_1.z
        .boolean((0, validation_1.labelZodErrors)("Auto assign to submitter"))
        .optional(),
});
exports.default = new ItemDefinition_1.ItemDefinition("Schedule", configSchema, dataSchema, new validation_1.ValidatorPipeline("Schedule Config Validator", []), new validation_1.ValidatorPipeline("Schedule Data Validator", []));
//# sourceMappingURL=Schedule.js.map